<template>
  <page :title="title">
    <div>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-toolbar dense color="grey lighten-3" flat>
                <v-icon>mdi-delete</v-icon>
                <v-toolbar-title>Delete Unreleased Claims Transaction Details</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <message :messages="messages"></message>
                <form>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-subheader class="queryLabel">{{ labels.docNo }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.tranType1 + " " + claimPayHeader.docNo }}</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider class="grey lighten-4"></v-divider>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.branchDesc }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.tranDate }}</v-subheader>
                        <span class="queryValue">{{ formatDisplayDate(claimPayHeader.tranDate) }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.department }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.departmentDesc }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.fund }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.fundDesc }}</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-subheader class="queryLabel">{{ labels.payeeAcctNo }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.payeeAcctNo }}</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-subheader class="queryLabel">{{ labels.titleName }} / {{ labels.name }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.titleName }} {{ claimPayHeader.name }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.addr1 }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.addr1 }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.addr2 }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.addr2 }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.addr3 }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.addr3 }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.addr4 }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.addr4 }}</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-subheader class="queryLabel">{{ labels.postCode }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.postCode }}</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-subheader class="queryLabel">{{ labels.stmtRef }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.stmtRef }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.curr }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.currDesc }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.exRate }}</v-subheader>
                        <span class="queryValue">{{ formatDisplayNumber(claimPayHeader.exRate, 7) }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.bankNo }}</v-subheader>
                        <div class="queryValue" v-for="item in filterBankList" :key="item.label">{{ item.label }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.cheque }}</v-subheader>
                        <span class="queryValue">{{ claimPayHeader.cheque }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.bankChrg }}</v-subheader>
                        <span class="queryValue">{{ formatDisplayNumber(claimPayHeader.bankChrg, 2) }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.bankChrgLoc }}</v-subheader>
                        <span class="queryValue">{{ formatDisplayNumber(claimPayHeader.bankChrgLoc, 2) }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.totAmt }}</v-subheader>
                        <span class="queryValue">{{ formatDisplayNumber(claimPayHeader.paytAmt, 2) }}</span>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ labels.totAmtLoc }}</v-subheader>
                        <span class="queryValue">{{ formatDisplayNumber(claimPayHeader.paytAmtLoc, 2) }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </form>
              </v-card-text>
              <v-flex xs12>
                <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel" :loading="submitting"
                  >{{ labels.cancel }}<v-icon dark right>mdi-cancel</v-icon></v-btn
                >
                <v-btn color="primary" @click.prevent="doPromptRemove" :loading="submitting"
                  >{{ labels.delete }}<v-icon right>mdi-delete</v-icon>
                </v-btn>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>This record will be deleted. (84)</p>
        <div class="queryValue">Document No.: {{ selected.docNo }}</div>
      </confirm>
    </div>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { parseISO } from 'date-fns'
import { formatDisplayNumber } from '@/utils/number'
import claimUnrelDelMixin from '@/mixins/claim/claimUnrelDelMixin'
import { formatDisplayDate } from '@/utils/date'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      breadcrumb: [],
      title: 'Delete Unreleased Claims Transaction',
      loading: true,
      currList: [],
      bankList: [],
      currRateList: [],
      disableCheqNo: true,
      tranDateRange: {},
      showTransDate: false,
      claimPayHeaderOrig: {},
      baseCurr: undefined,
      submitting: false,
      claimPayHeader: {
        fundDesc: undefined,
        branchDesc: undefined,
        cseStatDesc: undefined,
        tranType1Desc: undefined,
        inOutGstDesc: undefined,
        currDesc: undefined,
        prtClmPvDesc: undefined,
        departmentDesc: undefined,
        branch: undefined,
        fund: undefined,
        tranType1: undefined,
        docNo: undefined,
        dept: undefined,
        tranDate: undefined,
        payeeAcctNo: undefined,
        titleName: undefined,
        name: undefined,
        addr1: undefined,
        addr2: undefined,
        addr3: undefined,
        addr4: undefined,
        postCode: undefined,
        stmtRef: undefined,
        curr: undefined,
        exRate: undefined,
        paytAmt: undefined,
        paytAmtLoc: undefined,
        gstRegNo: undefined,
        inOutGst: undefined,
        deemGst: undefined,
        gstStat: undefined,
        gstAmt: undefined,
        gstAmtLoc: undefined,
        netAmt: undefined,
        netAmtLoc: undefined,
        bankAcctCurr: undefined,
        bankChrg: undefined,
        bankChrgLoc: undefined,
        riRcvyCurr: undefined,
        prtCseLoss: undefined,
        prtClmtName: undefined,
        prtLossDesc: undefined,
        prtClmPv: undefined,
        tranRel: undefined,
        clmClsd: undefined,
        cseStat: undefined,
        bankNo: undefined,
        acctNoSfx: undefined,
        cheque: undefined,
        taxInv: undefined,
        bankCurrAmt: undefined,
        payBank: undefined,
        payChqNo: undefined,
        drawerName: undefined,
        cashBkNo: undefined,
        payInSlipNo: undefined,
        bankTotLocAe: undefined,
        bankTotLoc: undefined,
        acctMth: undefined,
        acctYr: undefined,
        payInsd: undefined,
        docPrtd: undefined,
        paytAmtTax: undefined,
        paytAmtTaxLoc: undefined,
        addr5: undefined,
        addr6: undefined,
        name2: undefined,
        docNoAe: undefined
      },
      labels: {
        save: 'Save and Post',
        cancel: 'Cancel',
        clmtName: 'Claimant Name',
        clmItem: 'Claim Item',
        clmClsd: 'Close Claim',
        branch: 'Branch',
        fund: 'Fund',
        cseStat: 'Cause of Status',
        tranType1: 'Transaction Type',
        docNo: 'Claim Document No.',
        payChqNo: 'Cheque or GIRO',
        tranDate: 'Transaction Date',
        acctNoSfx: 'Suffix',
        inOutGst: 'GST I/O',
        deemGst: 'Deemed GST',
        curr: 'Payment Currency',
        exRate: 'Rate',
        riRcvyCurr: 'RI Recovery Currency',
        prtClmPv: 'Print Document',
        prtCseLoss: 'Print Cause of Loss',
        titleName: 'Title',
        prtClmtName: 'Print Claimant Name',
        name: 'Name',
        name2: 'Name2',
        prtLossDesc: 'Print Description of Loss',
        prtOffSettLtr: 'Print Offer Settlement Letter',
        addr1: 'Block/House No.',
        addr2: 'Street Name',
        addr3: 'Unit No.',
        addr4: 'Building Name',
        postCode: 'Postal Code',
        stmtRef: 'Statement Reference',
        bankNo: 'Bank No.',
        cheque: 'Cheque No.',
        bankAcctCurr: 'Bank Charges Currency',
        settCode: 'Settlement Code',
        clmResCat: 'Reserve Category',
        rcvrPi: 'Recovery from P&I',
        payeeAcctNo: 'Pay Account No.',
        clmPaytType: 'Payment Type',
        isSuppGstreg: 'Is Supplier GST Registered ?',
        theirTaxInv: 'Their Tax Invoice No.',
        dvInvDate: 'DV/Invoice Date',
        paytAmt: 'Total Payment',
        paytAmtLoc: 'Local Total Payment',
        paytAmtTax: 'Amount Taxable',
        paytAmtTaxLoc: 'Local Amount Taxable',
        gstStat: 'GST Status',
        gstRate: 'GST Rate',
        gstAmt: 'Total GST Amount',
        gstAmtLoc: 'Local GST Amount',
        netAmt: 'Net Amount',
        netAmtLoc: 'Local Net Amount',
        prtCclist: 'Print Carbon Copy',
        bankChrg: 'Bank Charges',
        bankChrgLoc: 'Bank Charges Local',
        paytAmtRes: 'Total Amount (in Reserve Currency)',
        prtClmDv: 'Print Discharge Voucher',
        totAmt: 'Total Amount',
        totAmtLoc: 'Local Total Amount',
        totAmtTax: 'Total Taxable Amount',
        totAmtTaxLoc: 'Local Total Taxable Amount',
        bankChrgRes: 'Bank Charges (in Reserve Currency)',
        bankDesc: 'Bank Balance',
        department: 'Department',
        address: 'Address',
        delete: 'Delete'
      },
      promptRemove: false,
      selectedRemove: {}
    }
  },
  methods: {
    async doFetch() {
      this.loading = true
      const apiUrl = this.menu.getClaimReleasePayDetailData
      if (apiUrl) {
        const expand = {
          branch: this.selected.branch,
          fund: this.selected.fund,
          tranType1: this.selected.tranType1,
          docNo: this.selected.docNo
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        if (result && result.data) {
          const { dataMap } = result.data
          const clmPaytHdr = dataMap.clmPaytHdr
          this.claimPayHeader.branch = clmPaytHdr.branch
          this.claimPayHeader.fund = clmPaytHdr.fund
          this.claimPayHeader.tranType1 = clmPaytHdr.tranType1
          this.claimPayHeader.docNo = clmPaytHdr.docNo
          this.claimPayHeader.dept = clmPaytHdr.dept
          this.claimPayHeader.tranDate = dataMap.tranDate
          this.claimPayHeader.payeeAcctNo = clmPaytHdr.payeeAcctNo
          this.claimPayHeader.titleName = clmPaytHdr.titleName
          this.claimPayHeader.name = clmPaytHdr.name
          this.claimPayHeader.addr1 = clmPaytHdr.addr1
          this.claimPayHeader.addr2 = clmPaytHdr.addr2
          this.claimPayHeader.addr3 = clmPaytHdr.addr3
          this.claimPayHeader.addr4 = clmPaytHdr.addr4
          this.claimPayHeader.postCode = clmPaytHdr.postCode
          this.claimPayHeader.stmtRef = clmPaytHdr.stmtRef
          this.claimPayHeader.curr = clmPaytHdr.curr
          this.claimPayHeader.exRate = clmPaytHdr.exRate
          this.claimPayHeader.paytAmt = clmPaytHdr.paytAmt
          this.claimPayHeader.paytAmtLoc = clmPaytHdr.paytAmtLoc
          this.claimPayHeader.gstRegNo = clmPaytHdr.gstRegNo
          this.claimPayHeader.inOutGst = clmPaytHdr.inOutGst
          this.claimPayHeader.deemGst = clmPaytHdr.deemGst
          this.claimPayHeader.gstStat = clmPaytHdr.gstStat
          this.claimPayHeader.gstAmt = clmPaytHdr.gstAmt
          this.claimPayHeader.gstAmtLoc = clmPaytHdr.gstAmtLoc
          this.claimPayHeader.netAmt = clmPaytHdr.netAmt
          this.claimPayHeader.netAmtLoc = clmPaytHdr.netAmtLoc
          this.claimPayHeader.bankAcctCurr = clmPaytHdr.bankAcctCurr
          this.claimPayHeader.bankChrg = clmPaytHdr.bankChrg
          this.claimPayHeader.bankChrgLoc = clmPaytHdr.bankChrgLoc
          this.claimPayHeader.riRcvyCurr = clmPaytHdr.riRcvyCurr
          this.claimPayHeader.prtCseLoss = clmPaytHdr.prtCseLoss
          this.claimPayHeader.prtClmtName = clmPaytHdr.prtClmtName
          this.claimPayHeader.prtClmPv = clmPaytHdr.prtClmPv
          this.claimPayHeader.tranRel = clmPaytHdr.tranRel
          this.claimPayHeader.clmClsd = clmPaytHdr.clmClsd
          this.claimPayHeader.cseStat = clmPaytHdr.cseStat
          this.claimPayHeader.bankNo = clmPaytHdr.bankNo
          this.claimPayHeader.acctNoSfx = clmPaytHdr.acctNoSfx
          this.claimPayHeader.cheque = clmPaytHdr.cheque
          this.claimPayHeader.taxInv = clmPaytHdr.taxInv
          this.claimPayHeader.bankCurrAmt = clmPaytHdr.bankCurrAmt
          this.claimPayHeader.payBank = clmPaytHdr.payBank
          this.claimPayHeader.payChqNo = clmPaytHdr.payChqNo
          this.claimPayHeader.drawerName = clmPaytHdr.drawerName
          this.claimPayHeader.cashBkNo = clmPaytHdr.cashBkNo
          this.claimPayHeader.payInSlipNo = clmPaytHdr.payInSlipNo
          this.claimPayHeader.bankTotLocAe = clmPaytHdr.bankTotLocAe
          this.claimPayHeader.bankTotLoc = clmPaytHdr.bankTotLoc
          this.claimPayHeader.acctMth = clmPaytHdr.acctMth
          this.claimPayHeader.acctYr = clmPaytHdr.acctYr
          this.claimPayHeader.payInsd = clmPaytHdr.payInsd
          this.claimPayHeader.docPrtd = clmPaytHdr.docPrtd
          this.claimPayHeader.paytAmtTax = clmPaytHdr.paytAmtTax
          this.claimPayHeader.paytAmtTaxLoc = clmPaytHdr.paytAmtTaxLoc
          this.claimPayHeader.addr5 = clmPaytHdr.addr5
          this.claimPayHeader.addr6 = clmPaytHdr.addr6
          this.claimPayHeader.name2 = clmPaytHdr.name2
          this.claimPayHeader.docNoAe = clmPaytHdr.docNoAe
          this.claimPayHeader.prtLossDesc = clmPaytHdr.prtLossDesc
          this.claimPayHeader.branchDesc = clmPaytHdr.branchDesc
          this.claimPayHeader.departmentDesc = clmPaytHdr.departmentDesc
          this.claimPayHeader.fundDesc = clmPaytHdr.fundDesc
          this.claimPayHeader.tranType1Desc = this.getDesc(this.getItemValue(clmPaytHdr.tranType1, this.tranTypeList1))
          this.claimPayHeader.cseStatDesc = this.getDesc(this.getItemValue(clmPaytHdr.cseStat, this.claimPayCseStatList))
          this.claimPayHeader.inOutGstDesc = this.getDesc(this.getItemValue(clmPaytHdr.inOutGst, this.gstIOs))
          this.claimPayHeader.currDesc = clmPaytHdr.currencyDesc
          this.claimPayHeader.prtClmPvDesc = this.getDesc(this.getItemValue(clmPaytHdr.prtClmPv, this.printDocOptsList))
          //
          // currency
          this.currList = dataMap.currList
          this.bankList = dataMap.activeBankList
          this.tranDateRange = dataMap.tranDateRange
          this.currRateList = dataMap.currRateList
          this.claimPayHeaderOrig = this.claimPayHeader
        } else {
          this.$toast.error('Unexpected server response')
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim release txn)')
      }
      this.loading = false
    },
    doCancel() {
      this.$router.push({ name: 'clmUnrelDel' })
    },
    doPromptRemove() {
      this.resetMessages()
      const remove = {
        branch: this.claimPayHeader.branch,
        tranType1: this.claimPayHeader.tranType1,
        docNo: this.claimPayHeader.docNo,
        fund: this.claimPayHeader.fund
      }
      this.selectedRemove = remove
      this.promptRemove = true
    },
    async doDelete() {
      this.resetMessages()
      if (
        this.selectedRemove &&
        this.selectedRemove.branch &&
        this.selectedRemove.tranType1 &&
        this.selectedRemove.docNo &&
        this.selectedRemove.fund
      ) {
        this.submitting = true
        const apiURI = this.menu.deleteUnrelClaimsTxn
        if (apiURI) {
          this.$http
            .post(apiURI, this.selected)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.submitting = false
              this.promptRemove = false
              this.doCancel()
            })
            .catch((err) => {
              this.submitting = false
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    parseISO(value) {
      if (value) {
        return parseISO(value)
      } else {
        return undefined
      }
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    formatDisplayDate(date) {
      return formatDisplayDate(date)
    },
    getDesc(obj) {
      return obj.label !== undefined ? obj.label : ''
    }
  },
  computed: {
    menu() {
      return this.$store.state.clmUnrelDel.menu
    },
    selected() {
      return this.$store.state.clmUnrelDel.sel
    },
    filterBankList() {
      return this.bankList.filter((list) => {
        return list.value === this.claimPayHeader.bankNo
      })
    }
  },
  created() {
    this.doFetch()
  },
  watch: {
    'claimPayHeader.tranType1': function (value) {
      if (value === 'W' || value === 'Y') {
        this.claimPayHeader.bankChrg = 0 - parseFloat(this.claimPayHeader.bankChrg)
        this.claimPayHeader.bankChrgLoc = 0 - parseFloat(this.claimPayHeader.bankChrgLoc)
        this.claimPayHeader.paytAmt = 0 - parseFloat(this.claimPayHeader.paytAmt)
        this.claimPayHeader.paytAmtLoc = 0 - parseFloat(this.claimPayHeader.paytAmtLoc)
      }
    }
  },

  mounted() {},
  mixins: [claimUnrelDelMixin, MessageMixin, commonAjaxMixin]
}
</script>
